import { CONFIG } from 'config/environment_variables';
import { SCRIPT_CONFIG } from 'constant/scriptLoader';
import { useScript } from 'hooks/useScript';
import useUser from 'hooks/useUser';
import { Logger } from 'utils/logger';

const agentID = CONFIG.QUARTERZIP_AGENT_ID?.trim();
const workspaceToken = CONFIG.QUARTERZIP_WORKSPACE_TOKEN;

export const useQuarterZip = () => {
  const { user } = useUser();
  const sdkStatus = useScript(SCRIPT_CONFIG.QUARTERZIP.url, {
    removeOnUnmount: false,
    id: SCRIPT_CONFIG.QUARTERZIP.id,
  });

  /**
   * Opens the Quarterzip agent panel.
   * Returns true if the call was dispatched, false if the SDK is not yet ready.
   */
  const openAgent = (): boolean => {
    if (!agentID) {
      Logger.error({
        enableInProduction: true,
        message: 'Quarterzip agent ID is not set',
      });
      return false;
    }

    if (sdkStatus !== 'ready' || !window.Quarterzip) {
      return false;
    }

    const resolvedUser = {
      id: user.id,
      email: user.email,
      displayName: `${user.first_name} ${user.last_name}`.trim(),
    };

    window.Quarterzip.open({
      workspaceToken,
      agentId: agentID,
      user: resolvedUser,
    });

    return true;
  };

  const closeAgent = () => {
    window.Quarterzip?.close();
  };

  return {
    openAgent,
    closeAgent,
  };
};
